import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NAME, UiState } from './ui.reducer';

// Lookup the 'Ui' feature state managed by NgRx
const getUiState = createFeatureSelector<UiState>(NAME);

const getLoaded = createSelector(getUiState, (state: UiState) => state.loaded);

const getListFormat = createSelector(getUiState, (state: UiState) => state.listFormat);

const getNavOpen = createSelector(getUiState, (state: UiState) => state.navOpen);

const getDenseMenu = createSelector(getUiState, (state: UiState) => state.denseMenu);

const getDisableGlobalBookFilter = createSelector(getUiState, (state: UiState) => state.disableGlobalBookFilter);

const getBreadcrumbs = createSelector(getUiState, (state: UiState) => state.breadcrumbs);

const getIsRootComponent = createSelector(getUiState, (state: UiState) => state.isRootComponent);

const getHeaderDetails = createSelector(getUiState, (state: UiState) => state.headerDetails);

const getSavedSettings = createSelector(getUiState, (state: UiState) => state.savedSettings);

const getPageNavigationOpen = createSelector(getUiState, (state: UiState) => state.pageNavigationOpen);

const getBackUrl = createSelector(getUiState, (state: UiState) => state.backUrl);

export const UiQuery = {
  getLoaded,
  getListFormat,
  getNavOpen,
  getBreadcrumbs,
  getHeaderDetails,
  getSavedSettings,
  getDenseMenu,
  getDisableGlobalBookFilter,
  getPageNavigationOpen,
  getIsRootComponent,
  getBackUrl,
};
